export const AUTHORIZATION_PERMISSIONS = {
  efficiencyPersonalView: 'insight:efficiency:personal:view',
  efficiencyTeamView: 'insight:efficiency:team:view',
  efficiencyBusinessView: 'insight:efficiency:business:view',
  efficiencySummaryView: 'insight:efficiency:summary:view',
  efficiencyComparisonView: 'insight:efficiency:comparison:view',
  efficiencyComparisonManage: 'insight:efficiency:comparison:manage',
} as const;

export type AuthorizationPermission =
  (typeof AUTHORIZATION_PERMISSIONS)[keyof typeof AUTHORIZATION_PERMISSIONS];

type AuthorizationSource = {
  permissions?: readonly string[];
  roles?: readonly string[];
};

/**
 * Frontend authorization adapter.
 *
 * Pages and actions should consume permission codes through this adapter. Role
 * checks remain available only while legacy modules are being migrated.
 */
export const createAuthorization = ({ permissions = [], roles = [] }: AuthorizationSource) => {
  const permissionSet = new Set(permissions.filter(Boolean));
  const roleSet = new Set(roles.filter(Boolean));

  const can = (permission: string) =>
    permissionSet.has('*:*:*') || permissionSet.has(permission);
  const canAny = (targetPermissions: readonly string[]) => targetPermissions.some(can);
  const hasRole = (role: string) => roleSet.has(role);
  const hasAnyRole = (targetRoles: readonly string[]) => targetRoles.some(hasRole);

  return {
    can,
    canAny,
    hasRole,
    hasAnyRole,
  };
};
